import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Row, Space, Typography } from 'antd';
import { useTrackingCode } from "react-hubspot-tracking-code-hook";

import { StepFormProps } from '../types/types';
import { useIntegrations } from "../context/integrations.context";
import { useResponsive } from "../utils/use-responsive";
import { FormPage } from "./contents/form-page";

const { Title } = Typography;

export const ConfirmationPage: React.FC<StepFormProps> = ( props ) => {
    const { isXs, isMobile } = useResponsive();
    const { getCodatRedirect } = useIntegrations();
    const companyId = localStorage.getItem('companyId');
    const [url, setURL] = useState<string>();

    const { setPathPageView } = useTrackingCode();
    setPathPageView("/connect-open-banking");

    useEffect(() => {
      if (companyId) {
        getCodatRedirect.execute(companyId).then(( data ) => {
          setURL(data?.redirect);
        }).catch(( error ) => {
          console.log('error', error);
        });
      }
    }, [companyId]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
      <FormPage displayFooter={true}>
        <Row justify="center">
          <Col span={20}>
            <Space direction={'vertical'} size={'large'} className={'full-width'}>
              <Card bordered={!isMobile} bodyStyle={isXs ? { padding: '0' } : { padding: '2rem' }}>
                <Space direction={"vertical"} size={'large'} className={'full-width'}>
                  <Row justify="center">
                    <Title level={2} style={{ textAlign: 'center', width: '100%' }}>Thanks for Signing Up</Title>
                    <Title level={4} style={{ textAlign: 'center', width: '100%' }}> To Receive your Indicative
                      Offer</Title>
                    <Button block type="primary" key="login" size="middle"
                            style={{ width: 'auto', marginBottom: "10px" }}>
                      <a href={url}>
                        Connect Here
                      </a>
                    </Button>
                    <Title level={5} style={{ textAlign: 'center', width: '100%' }}> Secure Connection with &quot;Read
                      Only&quot; access to your accounting and banking data.</Title>
                  </Row>
                </Space>
              </Card>
            </Space>
          </Col>
        </Row>
      </FormPage>
    );
  }
;
